import '../scss/_shortlist.scss';

window.toggleShortlistModal = function toggleShortlistModal() {
    var popup = document.getElementById('shortlist-popup');
    var mask = document.getElementById('shortlist-popup-mask');
    popup.classList.toggle('hidden');
    mask.classList.toggle('hidden');
    var catfishElement = document.getElementsByClassName('shortlist-catfish')[0];
    var thisCoCheckbox = document.getElementsByClassName('thisCompany')[0];
    if (thisCoCheckbox) {
        if (popup.classList.contains('hidden') == false && thisCoCheckbox.checked == false) {
            thisCoCheckbox.checked = true;
            tickBox(entry_id, thisCoCheckbox);
        }
    }
}

window.enquiryStart = function enquiryStart()
{
    dataLayer.push({ 'event': 'myTrackEvent', 'eventCategory': 'Enquiry Started', 'eventAction': 'submit', 'eventLabel': 'Enquiry-Started' })
    if (typeof hj !== 'undefined') {
        hj('tagRecording', ['Enquiry Started']);
    }
}


window.updateCheckbox = function updateCheckbox(el, setting) {
    //Company name is stored as a class, retrieve it
    var classNames = el.className.split(/\s+/)
    var companyName = "";
    for (var x = 0; x < classNames.length; x++) {
        if (classNames[x].indexOf("checkbox-") != -1) {
            companyName = classNames[x];
        }
    }
    //Set all instances of this class to the correct setting

    var elements = document.getElementsByClassName(companyName);
    for (var x = 0; x < elements.length; x++) {
        elements[x].checked = setting;
    }

}


if (document.getElementById('shortlist-checkboxes') && document.getElementsByClassName('company-checkboxes-wrapper') > 0) {
    document.getElementById('shortlist-checkboxes').innerHTML = document.getElementsByClassName('company-checkboxes-wrapper')[0].innerHTML;
}




window.submitAnalytics = function submitAnalytics(el) {
    //Parse current URL and check if we're on the directory or single entry
    var currentAddress = window.location;
    var path = currentAddress.pathname;

    var location = "";

    if (path.indexOf('directory') != -1) {
        location = "Directory"
    } else if (path.indexOf("-franchises/") != -1) {
        location = "Single Entry Popup"
    } else {
        location = "Catfish";
    }

    dataLayer.push({ 'event': 'myTrackEvent', 'eventCategory': 'Enquiry Submitted', 'eventAction': location, 'eventLabel': 'Enquiry-Submitted' })
}

window.disableShortlistSubmitButton = function disableShortlistSubmitButton() {
    var button = document.getElementsByClassName('send_enquiry_button');
    for (var i = 0; i < button.length; i++) {
        button[i].disabled = true;
    }
}